<template>
  <div class="privacy-policy">
    <div v-if="env.isApp" class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
        </template>
      </van-nav-bar>
    </div>
    <div class="page-container">
      <iframe class="iframe" :src="currentDocPath" frameborder="0" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDocPath: null,
      docPathMap: {
        echo: {
          en: '/official_site/echo/user-protocol.html',
        },
        joychat: {
          en: '/official_site/joychat/user-protocol.html',
        },
        joyu: {
          en: '/official_site/joyu/user-protocol.html',
        },
        kiko: {
          en: '/official_site/kiko/user-protocol.html',
        },
        vava: {
          ar: '/official_site/vava/user-protocol-ar.html',
          id: '/official_site/vava/user-protocol-id.html',
          pt: '/official_site/vava/user-protocol-pt.html',
          en: '/official_site/vava/user-protocol-en.html',
        },
        vibeo: {
          en: '/official_site/vibeo/user-protocol.html',
        },
        whonow: {
          en: '/official_site/whonow/user-protocol.html',
        },
      },
    }
  },
  mounted() {
    if (this.packageName) {
      if (this.docPathMap[this.packageName]) {
        if (this.docPathMap[this.packageName][this.$i18n.locale]) {
          this.currentDocPath = this.docPathMap[this.packageName][this.$i18n.locale]
        }
        //
        else {
          this.currentDocPath = this.docPathMap[this.packageName]['en']
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.privacy-policy {
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  .page-container {
    box-sizing: border-box;
    background-color: #ffffff;
    flex: 1;

    .iframe {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
